import Principal from '../screens/Principal.vue'
import CateOp from '../screens/CateOp'

export const routes = [     
    {path:'/igpm',name:'principal', component: Principal},   
    {path:'/igpm/:categoria',name:'categoria', component: CateOp},   
];